import { defineComponent, toRef, Ref } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import ScoreNumberOnly from './ScoreNumberOnly.CB';

export default defineComponent({
	props: {
		score: Number,
	},
	setup: (props) => {
		const score = toRef(props, 'score') as Ref<number>;
		const codeBehind = new ScoreNumberOnly(score);

		return setupComponent(codeBehind);
	},
});
